import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, className = "", level = "h2" }) => {
  const Tag = level;
  return (
    <Reveal className={className}>
      <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-gold/90">{overline}</p>
      <Tag className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight uppercase leading-none text-cream">
        {title}
      </Tag>
    </Reveal>
  );
};
